import { RemunerationKind, RemunerationUsecase, UserDefinedRow } from "../../model";
import { IncomeTypeMetadata, IncomeTypesLogic, } from "../../logic";
import { UsecaseValidationMessage } from "../UsecaseValidationMessage";
import { BaseUsecaseLogic } from "../BaseUsecaseLogic";

/** Client-side logic for RemunerationUsecase  */
export class RemunerationUsecaseLogic extends BaseUsecaseLogic {
  /** Gets validation message for IrIncomeTypeUsecase  */
  public getUcValidation(row: UserDefinedRow): UsecaseValidationMessage {
    const data: RemunerationUsecase = row.data || {};
    const codeData = this.getCodeData(data.kind);
    if (!codeData) {
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.noIrIncomeType",
      };
    }
    return null;
  }

  private getCodeData(kind: RemunerationKind): IncomeTypeMetadata {
    if (kind) {
      let code = 0;
      switch (kind) {
        case RemunerationKind.InitiativeFee:
          code = 202;
          break;
        case RemunerationKind.BonusPay:
          code = 203;
          break;
        case RemunerationKind.Commission:
          code = 220;
          break;
        case RemunerationKind.PerformanceBonus:
          code = 223;
          break;
        case RemunerationKind.ShareIssueForEmployees:
          code = 226;
          break;
        case RemunerationKind.ProfitSharingBonus:
          code = 233;
          break;
        case RemunerationKind.Undefined:
        default:
          code = 0;
          break;
      }
      return IncomeTypesLogic.getAll().find((x) => x.code === code);
    }
    return null;
  }
}
